// Long random per-device id (localStorage + cookie), sent with downloads and reviews to prove "downloaded on this device".
const KEY = "fmo_device";

const fresh = () => {
  const bytes = new Uint8Array(32);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
};

const readCookie = () => document.cookie.split("; ").find((c) => c.startsWith(`${KEY}=`))?.slice(KEY.length + 1);

export function deviceId() {
  let id = localStorage.getItem(KEY) || readCookie();
  if (!id || !/^[A-Za-z0-9-]{32,128}$/.test(id)) id = fresh();
  localStorage.setItem(KEY, id);
  document.cookie = `${KEY}=${id}; path=/; max-age=157680000; SameSite=Lax; Secure`;
  return id;
}

export const withDevice = (url) => `${url}${url.includes("?") ? "&" : "?"}device=${deviceId()}`;
export const DOWNLOAD_EVENT = "fmo:downloaded";

// Visitor platform for the download area: "ios" (iPhone / iPad, incl. iPadOS desktop UA) | "android" | "desktop".
export const device = () => {
  const ua = navigator.userAgent || "";
  if (/iPhone|iPad|iPod/i.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) return "ios";
  return /Android/i.test(ua) ? "android" : "desktop";
};
